import { queryArgs } from '@/utils'
import { defaultState } from './state'

export default {
	fetchWpResources ({ commit, dispatch, state, rootGetters }, { exclude = [] }) {
		let wpEndpoint = 'omapp/v1/resources'
		let params = ''
		if (!rootGetters.isFetched('wpResources')) {
			params = queryArgs.add('refresh', 1, params)
		}

		if (exclude.length) {
			params = queryArgs.add('excluded', exclude.join(','), params)
		}

		if (params.length) {
			wpEndpoint += '?' + params
		}

		const excludeCampaigns = exclude.includes('campaigns')

		// 	if (rootGetters.isFetched('wpResources') || rootGetters.isFetching('wpResources')) {
		// 		resolve()
		// 	}

		commit('fetching', 'wpResources', { root: true })

		return new Promise((resolve, reject) => {
			return this._vm.$api
				.get({ wpEndpoint, cached: false })
				.then(({ body }) => {
					commit('fetched', 'wpResources', { root: true })

					if (!excludeCampaigns) {
						dispatch('campaigns/updateCampaignsWithWpData', body.campaigns, { root: true })
						commit('setWpCampaigns', body.campaigns)
					}

					commit('setWpTaxonomies', body.taxonomies)
					commit('setWpConfig', body.config)
					commit('setWpPosts', body.posts)
					commit('setWpPostTypes', body.post_types)
					this._vm.$bus.$emit('fetchedWpResources', body)
					resolve(body)
				})
				.catch(error => {
					error.explanation = 'Something went wrong while fetching WordPress resources.'
					commit('setError', error, { root: true })
					reject(error)
					console.error({ error })
				})
		})
	},
	autogenerateWooCreds ({ commit, dispatch }) {
		return dispatch('saveWooCreds', { auto: true })
	},
	saveWooCreds ({ commit }, { key, secret, auto = false }) {
		commit('loading', 'wooconnect', { root: true })
		return new Promise((resolve, reject) => {
			this._vm.$api
				.post({ wpEndpoint: `omapp/v1/woocommerce/${auto ? 'autogenerate' : 'save'}` })
				.send({ key, secret })
				.then(({ body }) => {
					commit('doneLoading', 'wooconnect', { root: true })

					commit('fetched', 'wooKey', { root: true })
					commit('setWooConnected', Boolean(body.id))
					commit('setWooKey', body)

					this._vm.$bus.$emit('wooKeyFetched', body)

					resolve()
				})
				.catch((error) => {
					commit('closeAlerts', null, { root: true })

					commit('setWooConnected', false)
					error.explanation = `<strong>Something went wrong while attempting to ${auto ? 'autogenerate' : 'save'} the WooCommerce Keys.</strong>`
					if (this.$env.isEnv('development', 'dev')) {
						error.explanation += '<p>This is likely because you are in the <code>DEVELOPMENT</code> environment, and cookies could not be passed to the auto-generation request.</p>'
					}
					commit('setError', error, { root: true })
					commit('doneLoading', 'wooconnect', { root: true })

					reject(error)
					console.error({ error })
				})
		})
	},
	disconnectWoo ({ commit, dispatch }) {
		commit('loading', 'wooconnect', { root: true })
		return new Promise((resolve, reject) => {
			return this._vm.$api
				.post({ wpEndpoint: 'omapp/v1/woocommerce/disconnect' })
				.then(() => {
					commit('setWooConnected', false)
					commit('setWooKey', defaultState().wooKey)
					commit('doneLoading', 'wooconnect', { root: true })

					this._vm.$bus.$emit('wooKeyRemoved')

					resolve()
				})
				.catch((error) => {
					commit('closeAlerts', null, { root: true })

					error.explanation = '<strong>Something went wrong while attempting to disconnect WooCommerce.</strong>'
					commit('setError', error, { root: true })
					commit('doneLoading', 'wooconnect', { root: true })
					reject(error)
					console.error({ error })
				})
		})
	},
	fetchWooKey ({ getters, commit, rootGetters }, force = false) {
		if (!getters.isWooConnected) {
			return
		}

		return new Promise((resolve, reject) => {
			if (
				!force &&
				(
					rootGetters.isFetched('wooKey') ||
					rootGetters.isFetching('wooKey')
				)
			) {
				return resolve()
			}

			commit('fetching', 'wooKey', { root: true })

			return this._vm.$api
				.get({ wpEndpoint: 'omapp/v1/woocommerce/key' })
				.then(({ body }) => {
					commit('fetched', 'wooKey', { root: true })
					commit('setWooConnected', Boolean(body.id))
					commit('setWooKey', body)
					this._vm.$bus.$emit('wooKeyFetched', body)
					resolve()
				})
				.catch(error => {
					error.explanation = '<strong>Something went wrong while attempting to disconnect WooCommerce.</strong>'
					reject(error)
					console.error({ error })
				})
		})
	},
}
